import axios from 'axios';
import { IInquiry } from '@/shared/model/inquiry/inquiry.model';
import { buildConfigWithRecaptchaHeader } from '@/shared/utils/recaptcha';

const baseApiUrl = 'services/customerservice/api/tls';
export const INQUIRY_ENDPOINT = `${baseApiUrl}/inquiry`;

export default class InquiryService {
  public sendInquiry(token: string, inquiryDto: IInquiry): Promise<any> {
    return axios.post(INQUIRY_ENDPOINT, inquiryDto, buildConfigWithRecaptchaHeader(token)).then(res => res.data);
  }
}
